module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic7.2097c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic7.png
// module id = 590
// module chunks = 1